import React from 'react';
import PropTypes from 'prop-types';

const HeaderMegaMenuMenuTagline = ({ children }) => <p className="c-header-nav__tagline">{children}</p>

export default HeaderMegaMenuMenuTagline;

HeaderMegaMenuMenuTagline.propTypes = {
  children: PropTypes.node.isRequired,
};
